/* Polsk katalog for locale-payroll-employees-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'pay.personalia': 'Dane osobowe',
  'pay.personalInfo': 'Informacje osobowe',
  'pay.edit': 'Edytuj',
  'pay.documents': 'Dokumenty',
  'pay.description': 'Opis',
  'pay.contract': 'Umowa o pracę',
  'pay.open': 'Otwórz',
  'pay.download': 'Pobierz',
  'pay.delete': 'Usuń',
  'pay.employment': 'Zatrudnienie',
  'pay.positionAndAgreement': 'Stanowisko i umowa',
  'pay.searchOccupationCodes': 'Szukaj kodów zawodów ...',
  'pay.cancel': 'Anuluj',
  'pay.saveEmployment': 'Zapisz zatrudnienie',
  'pay.employmentFrom': 'Zatrudnienie od',
  'pay.employmentFromHint': 'Data, w której pracownik miał lub będzie miał pierwszy dzień pracy w Twojej firmie. Jest niezależna od tego, kiedy zacząłeś prowadzić księgowość w Plumme.',
  'pay.endDate': 'Data zakończenia',
  'pay.endDateHint': 'Zostaw pole puste, dopóki zatrudnienie trwa.',
  'pay.occupationCode': 'Kod zawodu',
  'pay.occupationCodeHint': 'Przeszukaj publiczny rejestr kodów zawodów i wybierz najlepiej pasujący. Pole jest używane do statystyk zawodów w Norwegii.',
  'pay.employmentType': 'Rodzaj stosunku pracy',
  'pay.employmentForm': 'Forma zatrudnienia',
  'pay.workingHoursScheme': 'System czasu pracy',
  'pay.workingHoursSchemeHint': 'Większość pracowników to „Bez zmian”, ale niektórzy mieszczą się w innych kategoriach.',
  'pay.hoursFullWeek': 'Godziny w pełnym tygodniu',
  'pay.salaryType': 'Rodzaj wynagrodzenia',
  'pay.hourlyPay': 'Stawka godzinowa',
  'pay.fixedPay': 'Wynagrodzenie stałe',
  'pay.ftePercent': 'Wymiar etatu',
  'pay.ftePercentHint': 'Wybierz szacunkowy wymiar etatu. Jeśli nie masz pewności, ustaw najbliższy procent.',
  'pay.fullTime': 'Pełny etat',
  'pay.partTime': 'Niepełny etat',
  'pay.employmentScope': 'Zakres zatrudnienia',
  'pay.adjustHoursBy': 'Dostosuj godziny według',
  'pay.perWeek': 'Na tydzień',
  'pay.perMonth': 'Na miesiąc',
  'pay.hoursPerWeek': 'Godziny tygodniowo',
  'pay.hoursPerMonth': 'Godziny miesięcznie',
  'pay.otherEntityNumber': 'Inny numer jednostki',
  'pay.optionalEntityNumber': 'Opcjonalny numer jednostki',
  'pay.priorPayOutsidePlumme': 'Wcześniejsze wynagrodzenie poza Plumme wypłacone przez Twoją firmę',
  'pay.priorPayHelp': 'Wpisz tylko wynagrodzenie, które nie jest zarejestrowane w Plumme, ale zostało wypłacone przez firmę.',
  'pay.warning': 'Ostrzeżenie:',
  'pay.forPublicStatistics': 'Do statystyki publicznej - wypełnij tylko, jeśli dotyczy',
  'pay.lastAdjustmentDate': 'Data ostatniej zmiany wynagrodzenia',
  'pay.salaryGrade': 'Stopień zaszeregowania',
  'pay.salaryGradePh': 'Np. 45',
  'pay.agreedSalary': 'Uzgodnione wynagrodzenie',
  'pay.save': 'Zapisz',
  'pay.annualSalary': 'Wynagrodzenie roczne',
  'pay.agreementTaxHeading': 'Umowa, dodatek urlopowy, podatek i składka pracodawcy',
  'pay.tax': 'Podatek',
  'pay.notFetchedFromAltinn': 'Nie pobrano z Altinn',
  'pay.salaryPerYear': 'Wynagrodzenie rocznie',
  'pay.holidayPay': 'Dodatek urlopowy',
  'pay.employerContribution': 'Składka pracodawcy',
  'pay.estimatedTax': 'Szacowany podatek',
  'pay.estimatedAnnualCost': 'Szacowany koszt roczny',
  'pay.noAgreedSalary': 'Nie wpisano uzgodnionego wynagrodzenia',
  'pay.taxCard': 'Karta podatkowa',
  'pay.taxCardHelp': 'Karty podatkowe nie są jeszcze pobierane. Zostanie to podłączone, gdy integracja ze Skatteetaten będzie gotowa.',
  'pay.fixedLines': 'Stałe linie',
  'pay.fixedLinesHelp': 'Linie płacowe, które zwykle są uwzględniane w każdej wypłacie.',
  'pay.newFixedLine': 'Utwórz nową stałą linię',
  'pay.seeFixedLines': 'Zobacz stałe linie płacowe',
  'pay.payslips': 'Paski wynagrodzenia',
  'pay.noPayslips': 'Nie utworzono jeszcze pasków wynagrodzenia.',
  'pay.gross': 'Brutto',
  'pay.paidOut': 'Wypłacono',
  'pay.employeePortal': 'Portal pracownika',
  'pay.employeePortalSub': 'Paski wynagrodzenia, podróże i wydatki pracownika.',
  'pay.needEmailFirst': 'Wpisz prawidłowy adres e-mail w profilu pracownika, zanim nadasz dostęp.',
  'pay.goToTravelExpenses': 'Przejdź do podróży i wydatków',
  'pay.saveEmployee': 'Zapisz pracownika',
  'pay.nationalId': 'Numer identyfikacyjny',
  'pay.hasInternationalId': 'Ma międzynarodowy identyfikator',
  'pay.name': 'Imię i nazwisko',
  'pay.phone': 'Numer telefonu',
  'pay.email': 'E-mail',
  'pay.address': 'Adres',
  'pay.country': 'Kraj',
  'pay.address1': 'Adres 1',
  'pay.streetAddress': 'Ulica i numer',
  'pay.address2': 'Adres 2',
  'pay.optional': 'Opcjonalne',
  'pay.postalCode': 'Kod pocztowy',
  'pay.postalPlace': 'Miejscowość',
  'pay.postalPlacePh': 'Miejscowość ...',
  'pay.accountNumber': 'Numer konta',
  'pay.hasForeignAccount': 'Ma zagraniczny numer konta',
  'pay.mainOrSecondaryEmployer': 'Dodatkowy/główny pracodawca',
  'pay.taxAndDutyRules': 'Zasady podatkowe i składkowe',
  'pay.noteOptional': 'Notatka (opcjonalnie)',
  'pay.notePh': 'Napisz notatkę ...',
  'pay.employees': 'Pracownicy',
  'pay.employeesHelp': 'Rejestr wszystkich pracowników firmy. Kliknij pracownika, aby zobaczyć dane osobowe, zatrudnienie, wynagrodzenie i paski wynagrodzenia.',
  'pay.allEmployees': 'Wszyscy pracownicy Twojej firmy',
  'pay.newEmployee': 'Nowy pracownik',
  'pay.newEmployeeHelp': 'Zarejestruj nowego pracownika z danymi osobowymi, zatrudnieniem i warunkami wynagrodzenia. Pracownik zostanie wtedy uwzględniony w listach płac i A-melding.',
  'pay.noEmployees': 'Brak pracowników',
  'pay.salaryTypeLabel': 'Rodzaj wynagrodzenia:',
  'pay.status': 'Status',
  'pay.statusHelp': 'Aktywne zatrudnienie oznacza, że pracownik jest uwzględniany w listach płac. Zakończone oznacza, że stosunek pracy ustał.',
  'pay.payroll': 'Płace',
  'pay.payrollSub': 'Naliczaj wynagrodzenia, obsługuj pracowników, okresy i dodatek urlopowy.',
  'pay.payrollModuleHelp': 'Moduł płac zbiera wszystko o pracownikach i wynagrodzeniach: naliczanie płac, składkę pracodawcy i zaliczkę na podatek, emeryturę (OTP), dodatek urlopowy, podróże i wydatki oraz ustawienia. Przełączaj podstrony w menu rozwijanym.',
  'pay.payrollPages': 'Strony płac',
  'pay.payrollPagesHelp': 'Przełączaj podstrony płac — Pracownicy, Wypłata wynagrodzeń, Składka pracodawcy i podatek, Emerytura/OTP, Stałe linie płacowe, Podróże i wydatki, Przegląd płac, Lista dodatku urlopowego, Ustawienia płac i Rodzaje wynagrodzeń.',
  'pay.employmentStatus': 'Status zatrudnienia',
  'pay.employmentStatusHelp': 'Pokazuje, czy zatrudnienie jest aktywne, czy zakończone. Aktywni pracownicy są uwzględniani w listach płac i zgłaszani w A-melding.',
  'pay.backToPayrollRun': 'Wróć do wypłaty wynagrodzeń',
  'pay.showAllEmployees': 'Pokaż wszystkich pracowników',
  'pay.yourEmployers': 'Twoi pracodawcy',
  'pay.yourClients': 'Twoi klienci',
  'pay.bgForEmployer': 'Kolor tła dla tego pracodawcy',
  'pay.bgColour': 'Kolor tła',
  'pay.receiptHelp': 'Zrób zdjęcie, prześlij, przeciągnij lub wklej. Wydatków bez dokumentu nie można przesłać.',
  'pay.takePhoto': 'Zrób zdjęcie',
  'pay.uploadFile': 'Prześlij zdjęcie/plik',
  'pay.remove': 'Usuń',
  'pay.registerExpense': 'Zarejestruj wydatek',
  'pay.receiptRequired': 'Wymagany dokument',
  'pay.category': 'Kategoria',
  'pay.pickCategory': 'Wybierz kategorię',
  'pay.date': 'Data',
  'pay.paidWith': 'Zapłacono przez',
  'pay.privateExpense': 'Wydatek prywatny',
  'pay.companyCard': 'Karta firmowa/konto operacyjne',
  'pay.amount': 'Kwota',
  'pay.currency': 'Waluta',
  'pay.whatIsExpenseFor': 'Czego dotyczy wydatek?',
  'pay.registerTravel': 'Zarejestruj podróż',
  'pay.sentForApproval': 'Wysyłane do zatwierdzenia',
  'pay.dateFrom': 'Data od',
  'pay.dateTo': 'Data do',
  'pay.travelType': 'Rodzaj podróży',
  'pay.travelWithExpenses': 'Podróż z wydatkami/przejazdem',
  'pay.drivingOnly': 'Tylko przejazd',
  'pay.travelWithSubsistence': 'Podróż z dietą',
  'pay.destination': 'Cel podróży',
  'pay.destinationPh': 'Miasto, klient lub miejsce',
  'pay.from': 'Z',
  'pay.startPlace': 'Miejsce początkowe',
  'pay.to': 'Do',
  'pay.endPlace': 'Miejsce docelowe',
  'pay.kilometres': 'Kilometry',
  'pay.purpose': 'Cel',
  'pay.purposeHelp': 'Jaki był cel podróży?',
  'pay.note': 'Notatka',
  'pay.createTravelClaim': 'Utwórz rozliczenie podróży',
  'pay.purposePh': 'Np. spotkanie z klientem w Drammen',
  'pay.whereDidYouGo': 'Dokąd była podróż?',
  'pay.norway': 'Norwegia',
  'pay.tolls': 'Opłaty drogowe',
  'pay.tollsPaidWith': 'Opłatę drogową zapłacono przez',
  'pay.fromDate': 'Od daty',
  'pay.toDate': 'Do daty',
  'pay.type': 'Typ',
  'pay.hotel': 'Hotel',
  'pay.otherAccommodation': 'Inny nocleg',
  'pay.guesthouse': 'Pensjonat lub barak',
  'pay.place': 'Miejsce',
  'pay.hotelOrPlace': 'Hotel lub miejsce',
  'pay.travelClaim': 'Rozliczenie podróży',
  'pay.rejectedByEmployer': 'Odrzucone przez pracodawcę',
  'pay.newAccommodation': 'Nowy nocleg',
  'pay.newTrip': 'Nowy przejazd',
  'pay.newExpense': 'Nowy wydatek',
  'pay.noLinesYet': 'Brak linii',
  'pay.employee': 'Pracownik',
  'pay.subsistence': 'Dieta',
  'pay.payslip': 'Pasek wynagrodzenia',
  'pay.close': 'Zamknij',
  'pay.netPaid': 'Wypłacono netto',
  'pay.period': 'Okres',
  'pay.payAndDeductions': 'Wynagrodzenie i potrącenia',
  'pay.grossPay': 'Wynagrodzenie brutto',
  'pay.withholdingTax': 'Zaliczka na podatek',
  'pay.expenseRefund': 'Zwrot wydatków/podróży',
  'pay.payslipPdfNote': 'Podgląd PDF i wysyłka zostaną podłączone, gdy generator pasków wynagrodzenia będzie dostępny w Plumme.',
  'pay.noPayslipsYet': 'Brak pasków wynagrodzenia.',
  'pay.myExpenses': 'Moje wydatki',
  'pay.noExpensesInView': 'Brak wydatków w tym widoku.',
  'pay.expenses': 'Wydatki',
  'pay.preview': 'Podgląd',
  'pay.loadingReceipt': 'Ładowanie dokumentu...',
  'pay.canStillDownload': 'Dokument nadal można pobrać ręcznie.',
  'pay.cannotPreview': 'Tego typu pliku nie można tutaj wyświetlić w podglądzie.',
  'pay.openNewTab': 'Otwórz w nowej karcie',
  'pay.myTravel': 'Moje podróże',
  'pay.noTravelInView': 'Brak podróży w tym widoku.',
  'pay.fetchingPortal': 'Wczytywanie portalu pracownika',
  'pay.portalFailed': 'Nie udało się wczytać portalu pracownika',
  'pay.back': 'Wstecz',
  'pay.noEmployers': 'Brak pracodawców',
  'pay.home': 'Start',
  'pay.homeHelp': 'Twoja strona pracownika u wybranego pracodawcy — paski wynagrodzeń, wydatki i podróże.',
  'pay.myPage': 'Moja strona',
  'pay.myPageHelp': 'Twoje osobiste konto w Plumme — profil, firmy i finanse prywatne.',
  'pay.signOut': 'Wyloguj się',
  'pay.paidByCompanyHint': 'Dokument trafia do księgowania, a nie do zwrotu.',
  'pay.paidPrivateHint': 'Kwota zostanie ci zwrócona razem z wynagrodzeniem.',
  'pay.expenseProject': 'Projekt',
  'pay.expenseProjectHint': 'Wydatek w ramach projektu można refakturować na klienta.',
  'pay.expenseNoProject': 'Bez projektu',
  'pay.myHours': 'Moje godziny',
  'pay.hoursThisMonth': '{time} w tym miesiącu',
  'pay.hoursHelp': 'Godziny zarejestrowane w projektach dla tego pracodawcy.',
  'pay.registerHours': 'Zarejestruj godziny',
  'pay.timeNew': 'Zarejestruj godziny',
  'pay.timeEdit': 'Edytuj wpis',
  'pay.timeDate': 'Data',
  'pay.timeProject': 'Projekt',
  'pay.timeActivity': 'Czynność',
  'pay.timeHours': 'Godziny',
  'pay.timeNote': 'Notatka',
  'pay.timeNotePh': 'Nad czym pracowałeś?',
  'pay.timePickProject': 'Wybierz projekt …',
  'pay.timePickActivity': 'Wybierz czynność …',
  'pay.timeSum': 'Suma',
  'pay.timeSaved': 'Wpis został zapisany',
  'pay.timeDeleted': 'Wpis został usunięty',
  'pay.timeFailed': 'Nie udało się zapisać wpisu.',
  'pay.timeLocked': 'Ewidencja czasu za ten okres jest oznaczona jako zakończona.',
  'pay.timeLockedThrough': 'Ewidencja czasu jest oznaczona jako zakończona do {date} włącznie.',
  'pay.timeEmptyTitle': 'Brak godzin w tym tygodniu',
  'pay.timeEmpty': 'Naciśnij „Zarejestruj godziny”, aby dodać pierwszy wpis.',
  'pay.timeNoProjectsTitle': 'Brak projektów',
  'pay.timeNoProjects': 'Twój pracodawca nie utworzył jeszcze projektów, w których możesz rejestrować godziny.',
  'pay.timePrevWeek': 'Poprzedni tydzień',
  'pay.timeNextWeek': 'Następny tydzień',
  'pay.myEmployeePage': 'Moja strona pracownika',
  'pay.myEmployeePageHelp': 'Twoja strona jako pracownika u pracodawcy — oddzielona od księgowości, którą ewentualnie prowadzisz. Tutaj widzisz swoje paski wynagrodzeń i rejestrujesz wydatki oraz podróże do zwrotu. Na górze przełączasz się między pracodawcami, u których jesteś zatrudniony.',
  'pay.employer': 'Pracodawca',
  'pay.employerHelp': 'Pracodawca, którego dotyczy ta strona. Jeśli pracujesz w kilku miejscach, przełączasz się tutaj — wtedy paski wynagrodzeń, wydatki i podróże pokazują dane wybranego pracodawcy.',
  'pay.payslipsHelp': 'Paski wynagrodzeń od pracodawcy — przegląd wynagrodzenia, potrąconego podatku i wypłaconej kwoty dla każdej listy płac. Dotknij, aby otworzyć.',
  'pay.expensesHelp': 'Wydatki poniesione z własnej kieszeni, które mają zostać zwrócone — np. paragon opłacony prywatnie. Prześlij je do zatwierdzenia, a zostaną zwrócone w ramach wynagrodzenia.',
  'pay.travelHelp': 'Rozliczenia podróży z kilometrówką, dietami i wydatkami związanymi z podróżą. Prześlij je do zatwierdzenia i zwrotu w ramach wynagrodzenia.',
  'pay.registerExpenseHelp': 'Zarejestruj nowy poniesiony wydatek — prześlij paragon, podaj kwotę i czego dotyczy. Trafi do pracodawcy do zatwierdzenia i zwrotu.',
  'pay.registerTravelHelp': 'Zarejestruj rozliczenie podróży — przejazdy (kilometrówka), diety i wydatki związane z podróżą. Trafi do pracodawcy do zatwierdzenia.',
  'pay.employmentStatusLabel.active': 'Aktywny stosunek pracy',
  'pay.employmentStatusLabel.ended': 'Zakończone',
  'pay.employmentStatusLabel.future': 'Rozpocznie się później',
  'pay.taxRuleNotSupported': 'jeszcze nieobsługiwane',
  'pay.taxRuleNotSupportedHint': 'Plumme oblicza tylko zwykły podatek i składkę pracodawcy. Listy płac z tym pracownikiem nie można zatwierdzić – rozlicz wynagrodzenie tego pracownika poza Plumme.',
  'pay.portalEmploymentEnded': 'Twój stosunek pracy zakończył się. Nadal możesz przeglądać paski wynagrodzeń, ale nie możesz przesyłać nowych wydatków, podróży ani godzin. Skontaktuj się z pracodawcą, jeśli masz wydatek do zwrotu.',
  'err.employeePortal.employmentEnded': 'Stosunek pracy zakończył się, a portal pracownika jest teraz tylko do odczytu. Poproś pracodawcę o zarejestrowanie wydatku.',
  'pay.foreignAmount.label': 'Kwota zapłacona w NOK',
  'pay.foreignAmount.hint': 'Paragon jest w {currency}. Podaj, ile faktycznie zapłaciłeś w koronach norweskich, na przykład z wyciągu bankowego. Wydatku nie można zatwierdzić bez kwoty w NOK.',
  'pay.foreignAmount.rateHint': 'Odpowiada kursowi {rate} NOK za {currency}.',
  'pay.foreignAmount.missing': 'Brak kwoty w NOK',
  'pay.foreignAmount.missingOnApproval': 'Wydatek „{description}” jest w {currency} i nie ma kwoty w NOK. Edytuj wiersz i wprowadź kwotę faktycznie zapłaconą w NOK przed zatwierdzeniem.',
  'err.payroll.foreignAmountMissingNok': 'Wydatek w walucie obcej nie ma kwoty w NOK. Wprowadź kwotę faktycznie zapłaconą w NOK przed zatwierdzeniem.',
  'pay.tabSalaryTax': 'Wynagrodzenie i podatek',
  'pay.tabPayslipsExpenses': 'Paski wynagrodzeń i wydatki',
  'pay.taxRuleOption.ordinary': 'Zwykłe',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen i terytoria zależne',
  'pay.taxRuleOption.seafarerDeduction': 'Specjalne odliczenie dla marynarzy',
  'pay.taxRuleOption.charity': 'Organizacja charytatywna lub pożytku publicznego',
  'pay.taxRuleOption.netPay': 'Wynagrodzenie netto',
  'pay.taxRuleOption.netPaySeafarer': 'Wynagrodzenie netto dla marynarzy',
  'pay.taxRuleOption.pensionSourceTax': 'Podatek u źródła od emerytur',
  'pay.taxRuleOption.nanny': 'Opiekunka w domu dziecka',
  'pay.taxRuleOption.homeWork': 'Praca najemna w domu prywatnym',
  'pay.taxRuleOption.taxFreeOrg': 'Organizacja zwolniona z podatku',
  'pay.employmentTypeOption.ordinary': 'Zwykły stosunek pracy',
  'pay.employmentTypeOption.maritime': 'Morski stosunek pracy',
  'pay.employmentTypeOption.freelance': 'Freelancer, zleceniobiorca lub osoba otrzymująca honorarium',
  'pay.employmentTypeOption.pension': 'Emerytura lub inny stosunek podlegający potrąceniu',
  'pay.employmentTypeOption.notEmployed': 'Niezatrudniony',
  'pay.employmentTypeOption.simplifiedPrivate': 'Uproszczony system rozliczeń, pracodawca prywatny',
  'pay.employmentTypeOption.simplifiedCharity': 'Uproszczony system rozliczeń, organizacja charytatywna',
  'pay.employmentTypeOption.foreignService': 'Zagraniczny stosunek służbowy',
  'pay.employmentTypeOption.boardFee': 'Wynagrodzenie członka zarządu',
  'pay.employmentFormOption.permanent': 'Na czas nieokreślony',
  'pay.employmentFormOption.temporary': 'Na czas określony',
  'pay.employmentFormOption.temporarySubstitute': 'Na czas określony jako zastępca na wezwanie',
  'pay.employmentFormOption.permanentHiredOut': 'Na czas nieokreślony, wynajęty',
  'pay.employmentFormOption.temporaryHiredOut': 'Na czas określony, wynajęty',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Stawka godzinowa - nadgodziny',
  'pay.fixedLine': 'Stały składnik',
  'pay.portalAccess.notInvited': 'Nie przyznano dostępu',
  'pay.portalAccess.active': 'Aktywny dostęp',
  'pay.portalAccess.revoked': 'Dostęp cofnięty',
  'pay.documentUploaded': 'Przesłano dokument.',
  'pay.documentsUploaded': 'Przesłano dokumenty.',
  'pay.documentDeleted': 'Usunięto dokument.',
  'pay.amountRequired': 'Wprowadź kwotę.',
  'pay.fixedLineDeleted': 'Usunięto stały składnik wynagrodzenia.',
  'pay.fixedLineDeleteFailed': 'Nie udało się usunąć stałego składnika wynagrodzenia.',
  'pay.emailRequiredFirst': 'Najpierw wprowadź prawidłowy adres e-mail w profilu pracownika.',
  'pay.portalAccessSent': 'Wysłano dostęp do {email}.',
  'pay.portalAccessRevokedToast': 'Dostęp cofnięty.',
  'pay.portalAccessSendFailed': 'Nie udało się wysłać dostępu.',
  'pay.portalAccessRevokeFailed': 'Nie udało się cofnąć dostępu.',
  'pay.saveEmployeeFailed': 'Nie udało się zapisać pracownika.',
  'pay.confirmDeleteDocument': 'Usunąć dokument „{name}”?',
  'pay.confirmDeleteFixedLine': 'Usunąć stały składnik wynagrodzenia „{line}” dla {name}?',
  'pay.confirmRevokePortalAccess': 'Cofnąć dostęp do portalu pracownika dla {name}?',
  'pay.taxCardValidUntil': 'Karta podatkowa ważna do',
  'pay.leaveOfAbsence': 'Urlopy',
  'pay.noLeaveRegistered': 'Brak zarejestrowanych',
  'pay.loginEmail': 'E-mail do logowania',
  'pay.lastSent': 'Ostatnio wysłano',
  'pay.revoked': 'Cofnięto',
  'pay.bankAccount': 'Konto bankowe',
  'pay.hoursInFullWeek': 'Godziny w pełnym tygodniu',
  'pay.uploading': 'Przesyłanie ...',
  'pay.newDocument': 'Nowy dokument',
  'pay.resendAccess': 'Wyślij dostęp ponownie',
  'pay.grantEmployeeAccess': 'Przyznaj pracownikowi dostęp',
  'pay.revoking': 'Cofanie ...',
  'pay.revokeAccess': 'Cofnij dostęp',
  'pay.portalAccessExplain': 'Dostęp jest powiązany z adresem e-mail i identyfikatorem pracownika. Panel pracownika korzysta z tego powiązania, gdy logowanie do portalu zostanie podłączone.',
  'pay.useStandardHolidayRate': 'Użyj stawki standardowej z ustawień płac ({rate} %)',
  'pay.priorYearSalaryHeading': 'Wynagrodzenie w {year}',
  'pay.payrollDataHidden': 'Dane płacowe są ukryte dla tego dostępu',
  'pay.payrollDataHiddenBody': 'Pracownicy, stałe pozycje płacowe i wypłaty wynagrodzeń znajdują się w osobnym dokumencie kadrowym. Twoja rola u tego klienta to {role}, a aplikacja nie mogła odczytać dokumentu kadrowego. Podróże i wydatki zaksięgowane w księgowości mogą więc nadal być wyświetlane.',
  'pay.unknownAccess': 'nieznany dostęp',
  'pay.readAccess': 'Dostęp do odczytu',
  'pay.registerFirstEmployee': 'Zarejestruj pierwszego pracownika, aby korzystać z list płac, kart podatkowych i A-melding.',
  'pay.mainEmployerOption': 'Główny pracodawca',
  'pay.secondaryEmployerOption': 'Dodatkowy pracodawca',
  'pay.documentsCount': 'Dokumenty: {count}',
  'pay.noDocumentsUploaded': 'Brak przesłanych dokumentów',
  'pay.cannotOpenDocument': 'Nie udało się otworzyć dokumentu.',
  'pay.cannotDownloadDocument': 'Nie udało się pobrać dokumentu.',
  'pay.endEmployment': 'Zakończ zatrudnienie',
  'pay.reopenEmployment': 'Przywróć zatrudnienie',
  'pay.earnedHolidayPayInYear': 'Nabyty dodatek urlopowy w {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Dodatek urlopowy, który nie został wypłacony przed datą rozpoczęcia w Plumme.',
  'pay.earnedTaxablePayInYear': 'Nabyte wynagrodzenie (podstawa podatku) w {year}',
  'pay.grossPayNotInPlummeHint': 'Wynagrodzenie brutto wypłacone przez firmę w {year}, które nie zostało ujęte w Plumme.',
  'pay.withheldTaxInYear': 'Potrącony podatek w {year}',
  'pay.priorYearAmountWarning': 'Kwoty za {year} wypełnij tylko wtedy, gdy nie są ujęte w innych wypłatach wynagrodzeń zarejestrowanych w Plumme.',
  'pay.agreedSalaryInternalNote': 'Uzgodnione wynagrodzenie służy wyłącznie jako dokumentacja wewnętrzna. Listy płac opierają się na stałych lub ręcznych pozycjach płacowych.',
  'pay.estimatedAnnualSalaryFrom': 'Szacowane roczne wynagrodzenie obliczono na podstawie: {summary}',
  'pay.fixedLinesRegisteredCount': 'Zarejestrowano: {count}',
  'pay.fixedLinesOnEmployee': 'Stałe pozycje płacowe przypisane do tego pracownika.',
  'pay.noFixedLinesRegistered': 'Nie zarejestrowano żadnych stałych pozycji.',
  'pay.internalDocumentationNote': 'To dokumentacja wewnętrzna. Listy płac korzystają ze stałych pozycji płacowych lub ręcznych pozycji w wypłacie wynagrodzenia.',
  'pay.noAgreedSalaryBody': 'Wpisz wynagrodzenie roczne lub stawkę godzinową, aby zobaczyć szacowany koszt roczny, dodatek urlopowy, składkę pracodawcy i podatek.',
  'pay.selectOccupationCode': 'Wybierz kod zawodu ...',
  'pay.noOccupationCodeMatch': 'Brak wyników dla „{query}”.',
  'pay.editEmployeeTitle': 'Edytuj pracownika',
  'pay.newEmployeeTitle': 'Nowy pracownik',
  'err.nativeValidation.payrollManualAMelding.1': 'Ręczna rejestracja A-melding wymaga norweskich płac.',
  'err.nativeValidation.payrollManualAMelding.2': 'Ręczne złożenie musi zostać wyraźnie potwierdzone.',
  'err.nativeValidation.payrollManualAMelding.3': 'Podaj prawidłowy okres raportowania, datę złożenia i ręczną referencję.',
  'err.nativeValidation.payrollManualAMelding.4': 'Data złożenia musi przypadać po miesiącu raportowania i nie może być w przyszłości.',
  'err.nativeValidation.payrollManualAMelding.5': 'Potwierdź dokładnie zaksięgowane listy płac w miesiącu raportowania.',
  'err.nativeValidation.payrollManualAMelding.6': 'Ręczna referencja raportu jest już zarejestrowana dla tego miesiąca.',
  'err.nativeValidation.pensionPremiumMutation.1': 'Płatność emerytalna wymaga norweskiej księgowości w NOK.',
  'err.nativeValidation.pensionPremiumMutation.2': 'Podaj prawidłowy dokument emerytalny i datę.',
  'err.nativeValidation.pensionPremiumMutation.3': 'Ta płatność emerytalna obsługuje tylko zweryfikowane stawki na 2026 dla strefy I.',
  'err.nativeValidation.pensionPremiumMutation.4': 'Płatność emerytalna korzysta z rachunku bankowego NOK 1920.',
  'err.nativeValidation.pensionPremiumMutation.5': 'Kwoty emerytalne muszą być skończonymi, nieujemnymi liczbami w pełnych øre.',
  'err.nativeValidation.pensionPremiumMutation.6': 'Płatności emerytalnej nie można zarejestrować przed datą księgową.',
  'err.nativeValidation.pensionPremiumMutation.7': 'Identyfikator księgowania emerytury jest już zarezerwowany.',
  'err.nativeValidation.pensionPremiumMutation.8': 'Historia numeracji emerytur jest nieprawidłowa.',
});
